angular.module('impactx.opengovernmentdata').controller('CompanySizeListCtrl', [
    CompanySizeListCtrl]);

function CompanySizeListCtrl() {
    this.meta = {
        rowTemplate: 'modules/opengovernmentdata/templates/companysizelist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/opengovernmentdata/companysize/list',
        ctrl: this,
        id: "companysizelist",
        excelExport: true
    };

    this.getMeta = function() {
        return this.meta;
    };
}